
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/manage/risk",
      function () {
        return require("private-next-pages/ir/manage/risk.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ir/manage/risk"])
      });
    }
  